import { Button } from '@mui/material';
import React, { useContext } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import API from '../../api';
import { FileMultipleUploader, FormInput, FormTextArea, PageHeader } from '../../components';
import { FormRadio } from '../../components/form/FormRadio';
import { SnackbarContext } from '../../contexts';
import { useLabel } from '../../hooks';

export const MypageInquiryAddPage = (props) => {
  const history = useHistory();
  const { t } = useTranslation();
  const { updateSnackbar } = useContext(SnackbarContext);
  const { ERROR } = useLabel();

  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
    setValue,
    control,
  } = useForm({
    defaultValues: {
      type: 'Member',
      title: '',
      content: '',
      files: [],
    },
  });

  const validations = {
    title: {
      required: ERROR.TITLE_BLANK,
      validate: (value) => {
        if (!value.trim()) {
          return ERROR.TITLE_BLANK;
        }
        return true;
      },
    },
    content: {
      required: ERROR.CONTENT_BLANK,
      validate: (value) => {
        if (!value.trim()) {
          return ERROR.CONTENT_BLANK;
        }
        return true;
      },
    },
  };

  const handlePrev = () => {
    history.goBack();
  };

  const onSubmit = (data) => {
    // API 호출
    API.User.PostInquiry(data).then(
      (res) => {
        let result = res.data;
        history.push('/request_complete?type=mypage');
      },
      (err) => {
        updateSnackbar({
          type: 'error',
          open: true,
          message: err.data.message,
        });
      },
    );
  };

  return (
    <article className='basic-page'>
      <PageHeader type='credit' title={`${t('ONETOONE_INQUIRY')}`}></PageHeader>
      {/* <Breadcrumbs content='credit' title={'1:1 상담 문의'}></Breadcrumbs> */}
      <article className='content__wrapper'>
        <form id='inquiry-form' noValidate onSubmit={handleSubmit(onSubmit)}>
          <section className='form__container'>
            <ul className='grid w-[945px]'>
              <div style={{ gridColumn: '1/3' }}>
                <FormRadio
                  name='type'
                  control={control}
                  label={t('CATEGORY')}
                  menus={[
                    { label: 'SIGNUP_WITHDRAWAL', value: 'Member' },
                    { label: 'METHODOLOGY', value: 'Methodology' },
                    { label: 'MANAGEMENT', value: 'Project' },
                    { label: 'REDUCTION_CERT', value: 'ReductionCert' },
                    { label: 'POP_CREDIT_VRC', value: 'ZCCredit' },
                    { label: 'ETC', value: 'ETC' },
                  ]}
                  radioGroupSx={{ gap: 0 }}
                />
              </div>
              <div style={{ gridColumn: '1/3', marginTop: 16 }}>
                <FormInput
                  label={t('TITLE')}
                  required
                  placeholder={t('TITLE')}
                  error={errors.title}
                  {...register('title', {
                    required: validations.title.required,
                    validate: validations.title.validate,
                  })}
                />
              </div>
              <div style={{ gridColumn: '1/3', marginTop: 16, marginBottom: 16 }}>
                <FormTextArea
                  label={t('CONTENT')}
                  required
                  rows={12}
                  placeholder={t('CONTENT')}
                  maxLength={500}
                  error={errors.content}
                  {...register('content', {
                    required: validations.content.required,
                    validate: validations.content.validate,
                  })}
                />
              </div>
              <FileMultipleUploader
                value={watch('files')}
                onChange={(value) => setValue('files', value)}
                meta={{
                  key: 'files',
                  type: 'file',
                  label: 'FILE',
                  path: 'dummy',
                  max: 10,
                  style: { gridColumn: '1/3' },
                }}
              ></FileMultipleUploader>
            </ul>
          </section>
          <article className='flex justify-between w-[945px] gap-8 mt-[2rem]'>
            <Button variant='outlined' onClick={handlePrev}>
              {t('PREV')}
            </Button>
            <Button variant='contained' color='primary' type='submit' form='inquiry-form'>
              {t('SUBMIT')}
            </Button>
          </article>
        </form>
      </article>
    </article>
  );
};
